export default __webpack_public_path__ + "static/media/web_screen_chat_fr.41ca4d07.png";